export const appointementInitialValues = {
  siteLogo:
    "https://www.cardinalplumbingva.com/wp-content/uploads/2022/11/Asset-1-1-1-3.svg",
  siteColor: "#DA1A32", // enum["#007BFF"]
  selectedData: {},
  selectedQuestionsData: {},
  service: "",
  serviceCategory: "",
  questionsData: [],
  subQuestionData: [],
  serviceType: "",
  systemAge: "",
  unitLocated: "",
  diagnosticFee: false,
  additionalInfo: "",
  cName: "",
  phoneNumber: "",
  accountPhoneNumber: "",
  email: "",
  customerType: "", // enum[existingCustomer, newCustomer]
  streetAddress: "",
  unitNumber: "",
  state: "",
  city: "",
  zipCode: "",
  isOwner: false,
  invalidAddressError: "",
  isValidAddress: "onEdit", //enum [valid, inValid, onEdit]
  isAddNewAddress: false,
  formattedAddress: "",
  addressId: null,
  postalAddress: {},
  customerData: {},
  customerError: "",
  appointmentObj: {},
  addresses: [],
  appointmentDate: null,
  appointmentTime: null,
  appointmentText: "",
  tempData: {},
};
